import { render, staticRenderFns } from "./AddManualPointPopup.vue?vue&type=template&id=c2c46140&scoped=true&"
import script from "./AddManualPointPopup.vue?vue&type=script&lang=js&"
export * from "./AddManualPointPopup.vue?vue&type=script&lang=js&"
import style0 from "./AddManualPointPopup.vue?vue&type=style&index=0&id=c2c46140&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c46140",
  null
  
)

export default component.exports